// extracted by mini-css-extract-plugin
export default {"link":"hVWIxvnfZ08o9s2Y39P_"};